import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RunCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"run_circle"}/>
}
